import type { AnyObject, ErrorDetails, Maybe } from '@/types';
import { getObjectKeys } from '@/utils/helpers';

/**
 * Ajoute un préfixe à chaque valeur définie dans l'objet "errorDetails" passé en paramètres.
 * Cette valeur modifiée correspond ainsi, dans le dictionnaire i18n, à l'endroit où
 * récupérer le message d'erreur dans la langue actuellement sélectionnée par l'utilisateur.
 */
export default function prefixErrorDetailsMessageKeys<TVal extends AnyObject>(
  i18nPrefixKey: string,
  errorDetails: Maybe<ErrorDetails<TVal>>,
): ErrorDetails<TVal> {
  if (!errorDetails) {
    return {};
  }

  return getObjectKeys(errorDetails).reduce((acc, fieldName) => {
    const errors = errorDetails[fieldName];
    if (errors) {
      acc[fieldName] = errors.map((errKey) => `${i18nPrefixKey}.${errKey}`);
    }
    return acc;
  }, {} as ErrorDetails<TVal>);
}
